import { SrciConsumer } from "@payair/srci-sdk/models/SrciConsumer"
import { Consumer } from "../models/SRCiInputData"

const normalizeOptionalText = (value: string | undefined): string | undefined => {
  const normalizedValue = value?.trim()
  return normalizedValue || undefined
}

export const buildSrciConsumerPrefill = (consumer: Consumer): SrciConsumer | undefined => {
  const emailAddress = normalizeOptionalText(consumer.emailAddress)
  const firstName = normalizeOptionalText(consumer.firstName)
  const lastName = normalizeOptionalText(consumer.lastName)
  const phoneCountryCode = normalizeOptionalText(consumer.mobileNumber?.countryCode)
  const phoneNumber = normalizeOptionalText(consumer.mobileNumber?.phoneNumber)
  const countryCode = normalizeOptionalText(consumer.countryCode)
  const identityValue = normalizeOptionalText(consumer.consumerIdentity?.identityValue)

  const prefill: SrciConsumer = {
    ...(emailAddress ? { emailAddress } : {}),
    ...(firstName ? { firstName } : {}),
    ...(lastName ? { lastName } : {}),
    ...(phoneCountryCode && phoneNumber
      ? {
          mobileNumber: {
            countryCode: phoneCountryCode,
            phoneNumber,
          },
        }
      : {}),
    ...(countryCode ? { countryCode } : {}),
    ...(identityValue
      ? {
          consumerIdentity: {
            identityValue,
            ...(consumer.consumerIdentity.identityProvider
              ? { identityProvider: consumer.consumerIdentity.identityProvider }
              : {}),
            ...(consumer.consumerIdentity.identityType ? { identityType: consumer.consumerIdentity.identityType } : {}),
            ...(consumer.consumerIdentity.type ? { type: consumer.consumerIdentity.type } : {}),
          },
        }
      : {}),
  }

  return Object.keys(prefill).length ? prefill : undefined
}
